/* ============================================================
   MAISON CANDELIA — newsletter-popup.js
   Pop-up newsletter — apparaît après 8s, cookie 7 jours
   Fix SimGym v2 : s'affiche UNIQUEMENT sur la homepage.
   sessionStorage évite la réapparition dans la même session.
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.querySelector('.newsletter-popup-overlay');
  if (!overlay) return;

  var COOKIE_NAME   = 'mc_newsletter_dismissed';
  var SESSION_KEY   = 'mc_popup_dismissed';
  var COOKIE_DAYS   = 7;

  // Afficher UNIQUEMENT sur la homepage — toutes les autres pages exclues
  var isHomepage = document.body.className.indexOf('template-index') !== -1;
  if (!isHomepage) return;

  function getCookie(name) {
    return document.cookie.split(';').some(function (c) {
      return c.trim().indexOf(name + '=') === 0;
    });
  }

  function setCookie(name, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=1; expires=' + d.toUTCString() + '; path=/';
  }

  function closePopup() {
    overlay.classList.remove('visible');
    setCookie(COOKIE_NAME, COOKIE_DAYS);
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
  }

  // Double vérification : cookie ET session
  var alreadyDismissed = getCookie(COOKIE_NAME);
  var sessionDismissed = false;
  try { sessionDismissed = !!sessionStorage.getItem(SESSION_KEY); } catch (e) {}

  if (!alreadyDismissed && !sessionDismissed) {
    setTimeout(function () { overlay.classList.add('visible'); }, 8000);
  }

  // Fermeture via bouton ×
  var closeBtn = overlay.querySelector('.newsletter-popup__close');
  if (closeBtn) closeBtn.addEventListener('click', closePopup);

  // Fermeture via « Non merci »
  var skipBtn = overlay.querySelector('.newsletter-popup__skip');
  if (skipBtn) skipBtn.addEventListener('click', closePopup);

  // Fermeture via clic sur l'overlay (hors popup)
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  // Fermeture via Échap
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('visible')) closePopup();
  });

  // Soumission du formulaire
  var form = overlay.querySelector('.newsletter-popup__form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      if (emailInput && emailInput.value) {
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.textContent = '\u2713 Bienvenue dans l\'atelier !'; btn.disabled = true; }
        setTimeout(closePopup, 2000);
      }
    });
  }
});
